module.exports = __webpack_public_path__ + "static/michael-dell-03c7d30e0a7e1b3ca196a1b06877ac52.jpg";